import { createDynamicThunk } from ".";

/**
 * LIST AuditForms
 */
export const fetchAuditFormsThunk = createDynamicThunk({
  typePrefix: "auditForms/fetchAuditFormsThunk",
  useHandleSearch: true,
});

/**
 * LIST Processes
 */
export const fetchAFProcessesThunk = createDynamicThunk({
  typePrefix: "processes/fetchProcessesThunk",
  endpoint: "/processes/fetchWithoutPagination",
  method: "POST",
});


export const fetchAuditFormDetailThunk = createDynamicThunk({
  typePrefix: "auditForms/fetchAuditFormDetailThunk",
  endpoint: "/auditForms",
  method: "GET",
});

export const addAuditFormThunk = createDynamicThunk({
  typePrefix: "auditForms/addAuditFormThunk",
  endpoint: "/auditForms",
  method: "POST",
});

export const editAuditFormThunk = createDynamicThunk({
  typePrefix: "auditForms/editAuditFormThunk",
  endpoint: "/auditForms/edit",
  method: "GET",
});

export const updateAuditFormThunk = createDynamicThunk({
  typePrefix: "auditForms/updateAuditFormThunk",
  endpoint: "/auditForms",
  method: "PUT",
});